export { CategoryPage, getCfVars } from './CategoryPage';
